import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
import { getGallery } from "../Service/Api";

const S3_url = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com";

const MunGallery = ({ items = [] }) => {
  const [data, setData] = useState(items);
  const [loading, setLoading] = useState(true);

  const fallbackItems = [
    { title: "NCS MUN", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
    { title: "Debate Room", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
    { title: "Conference Hall", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
    { title: "Delegate View", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (items.length > 0) {
          setData(items);
          return;
        }

        const galleryData = await getGallery();
        const filteredData = galleryData
          .filter((item) => item.category === "NcsMUN")
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .slice(0, 6);

        setData(filteredData.length > 0 ? filteredData : fallbackItems);
      } catch (error) {
        console.error("Error fetching MUN gallery data:", error);
        setData(fallbackItems);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [items]);

  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="mun-gallery-wrap">
      <div className="row">
        <Slider {...settings}>
          {(loading ? fallbackItems : data).map((item, index) => (
            <div className="item" key={item._id || item.title || index}>
              <div className="gallery-item">
                <div className="project-thumb gal-big">
                  <Link to={item._id ? `/ncs-mun-gallery?id=${item._id}` : "/ncs-mun-gallery"}>
                    <LazyLoad>
                      <img
                        src={`${S3_url}/${item.attachments?.[0]}`}
                        alt={item.title || "NCS MUN"}
                        className="img-fluid"
                      />
                    </LazyLoad>
                  </Link>
                </div>
                <div className="project-content">
                  <h2 className="title">{item.title}</h2>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="mun-view-all-wrap" >
        <Link className="mun-view-all-btn" to="/ncs-mun-gallery" style={{margin: 'auto'}}>
          View All
        </Link>
      </div>
    </div>
  );
};

export default MunGallery;
